import { Metamodel } from 'shell-models-lib';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { TabularTypeSettings } from 'app/model/dataflow/dataset-settings/tabular-type-settings';
import { IntegerDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';

@Metamodel.model({
    name: adfModelTypeMap.dynamics.dataflowSettings
})
export class DynamicsSettings extends TabularTypeSettings {
    public alternateKeyName: DataFlowExpression;
    public timeout: DataFlowExpression;
    public sinkImportSchema: boolean;

    public getDatasetType(): string {
        return adfModelTypeMap.dynamics.datasetType;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Dynamics;
    }

    public getIconClass(): string {
        return 'i-100x100-dynamics_365';
    }

    public getSubFormat(): string {
        return undefined;
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.alternateKeyName = this.transform.createTemplatableExpression();
        this.timeout = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE, '30');
    }
}
